namespace RioERP.Orders {
    export interface AddBookForm {
        OrderId: Serenity.IntegerEditor;
        BookIsbn: Serenity.StringEditor;
    }

    export class AddBookForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.AddBook';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AddBookForm.init)  {
                AddBookForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(AddBookForm, [
                    'OrderId', w0,
                    'BookIsbn', w1
                ]);
            }
        }
    }
}
